import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {
  ExpertiseService, IDownloadExpertiseFile,
  IGetConsentFormPdfInput,
  ISignedConsentPdfFileModelMio,
  IUploadSignedConsentPdfFileResult
} from "../../../../shared/services/expertise.service";

declare function tsSignFile(options: ISignFileOptions, onSuccessCallback, onErrorCallback?);

@Component({
  selector: 'app-form-pdf-signature',
  templateUrl: './form-pdf-signature.component.html',
  styleUrls: ['./form-pdf-signature.component.scss']
})
export class FormPdfSignatureComponent implements OnInit {

  uploadSignedConsentPdfFileResult: IUploadSignedConsentPdfFileResult;
  signError = '';
  isSignedFile: boolean = false;
  isShowSignComponent: boolean = false;
  completePercent: number = 0;
  currentFile: IPdfSignFIle;
  signedFileBlob: any;
  signedFileForServer: any;

  interval: any;
  fileUrl: string;


  constructor(protected dialogRef: MatDialogRef<FormPdfSignatureComponent>,
              @Inject(MAT_DIALOG_DATA) public data: IFormPdfSignatureComponentData,
              private toastr: ToastrService,
              private expService: ExpertiseService) {
  }


  ngOnInit() {

    if (this.data.signType === 'mio_sample_ecp') {
      this.getSamplePDF();
    } else if (this.data.signType === 'mio_consent_file') {
      this.getConsentFormPdf();
    }

    this.interval = setInterval(() => {
      if (this.completePercent < 80) {
        this.completePercent += 10;
      } else {
        clearInterval(this.interval);
      }
    }, 50);
  }

  getSamplePDF() {
    this.expService.getSamplePdfFile().subscribe(res => {
      this.fileUrl = this.expService.generateFileLink(res);
      this.completePercent = 100;
      clearInterval(this.interval);

      setTimeout(() => {
        this.showSignComponent();
      }, 500);
    }, error => {
      if (error.status === 409 && error.error) {
        this.toastr.error(error.error, '', {timeOut: 5000});
        this.dialogRef.close({redirectToListOnError: true});
        return;
      }

      setTimeout(() => {
        this.close();
      }, 500);
    })
  }

  getConsentFormPdf() {
    const obj: IGetConsentFormPdfInput = {
      objectName: this.data.info.objectName,
      conclusionNumber: this.data.info.documentNumber,
      conclusionDate: this.data.info.documentDate
    }
    this.expService.getConsentFormPdf(obj).subscribe(res => {
      this.fileUrl = this.expService.generateFileLink(res);
      this.completePercent = 100;
      clearInterval(this.interval);

      setTimeout(() => {
        this.showSignComponent();
      }, 500);
    }, error => {
      if (error.status === 409 && error.error) {
        this.toastr.error(error.error, '', {timeOut: 5000});
        this.dialogRef.close({redirectToListOnError: true});
        return;
      }
      setTimeout(() => {
        this.close();
      }, 500);
    })
  }

  showSignComponent() {
    this.isShowSignComponent = true;
    if (this.fileUrl) {
      this.currentFile = {
        name: this.expService.createFileName(this.data?.info?.documentNumber),
        url: this.fileUrl,
        downloadName: this.expService.createFileName(this.data?.info?.documentNumber),
        base64String: '',
      };
      this.signFileAndSaveSignature();
    }
  }

  downloadSignedMioConsentFile() {
    const body: IDownloadExpertiseFile = {
      fileID: this.uploadSignedConsentPdfFileResult.authorConsentFileID,
      expertiseID: this.uploadSignedConsentPdfFileResult.expertiseID,
      isKenml: false,
      remotePSD: false
    };

    this.expService.downloadExpertiseFile(body, this.expService.createFileName(this.data?.info?.documentNumber));
  }

  close() {
    if (this.isSignedFile) {
      if (this.data.signType === 'mio_sample_ecp') {
        this.dialogRef.close(true);
      } else if (this.data.signType === 'mio_consent_file') {
        this.dialogRef.close(this.uploadSignedConsentPdfFileResult);
      }
      return;
    }
    this.dialogRef.close(false);
  }

  signFileAndSaveSignature() {
    tsSignFile(
      {
        url: this.currentFile?.url || '',
        filename: this.expService.createFileName(this.data?.info?.documentNumber),
        verbose: false,
        log: true,
        signMethod: "cms",
        alert: true,
        downloadMethod: 'js',
        saveResultToFile: false,
      },
      (result) => {
        // console.log(`=== result = `, result);
        // перекодируем полученный файл в бинарный вид и сохраним его в контекст браузера
        // let url = window.URL.createObjectURL(blobFile);
        this.signedFileBlob = new Blob([this._base64ToArrayBuffer(result)], {
          type: 'octet/stream',
        });
        this.signedFileForServer = this._convertBlobToFile(this.signedFileBlob);

        console.log(`=== Перед сохранение состояния на сервере = `, this.signedFileForServer);
        if (this.data.signType === 'mio_sample_ecp') {
          this.signSamplePDF();
        } else if (this.data.signType === 'mio_consent_file') {
          this.uploadSignedConsentPdfFile();
        }
      },
      (error) => {
        console.error('Произошла ошибка: ' + error);
        if (error === 'TS_USER_CANCELED') {
          this.toastr.warning('Операция подписи файла отменена!');
        }
        this.dialogRef.close();
      }
    );
  }

  signSamplePDF() {
    console.log('signSamplePDF')
    this.expService.uploadSignedSamplePdfFile(this.data.info.livingComplexID, this.signedFileForServer).subscribe(_ => {
        this.toastr.success('Файл согласия заказчика проекта сформирован!');
        this.isSignedFile = true;
        this.signError = '';
      },
      error => {
        if (error.status === 409 && error.error) {
          this.signError = error.error;
          this.toastr.error(error.error, '', {timeOut: 5000});
          // this.dialogRef.close({redirectToListOnError: true});
        }
      });
  }

  uploadSignedConsentPdfFile() {
    const object: ISignedConsentPdfFileModelMio = {
      expertiseId: this.data.info.expertiseID,
      documentNumber: this.data.info.documentNumber,
      documentDate: this.data.info.documentDate,
      expertiseType: this.data.info.expertiseType,
      isIntegration: false,
      isActive: false,
      livingComplexID: this.data.info.livingComplexID,
      attachment: this.signedFileForServer,
      regionID: this.data.info.regionID
    }
    this.expService.uploadSignedConsentPdfFile(object).subscribe(res => {
        if (res.errorStatus > 0) {
          this.signError = 'Ошибка, обратитесь разработчикам!';
          this.toastr.error('Ошибка', '', {timeOut: 5000});
        } else {
          this.uploadSignedConsentPdfFileResult = res;
          this.data.info.expertiseID = res.expertiseID;
          this.toastr.success('Файл согласия автора проекта успешно подписан!');
          this.isSignedFile = true;
          this.signError = '';
        }
      },
      error => {
        if (error.status === 409 && error.error) {
          this.signError = error.error;
          this.toastr.error(error.error, '', {timeOut: 5000});
          // this.dialogRef.close({ redirectToListOnError: true });
        }
      })
  }

  _convertBlobToFile(theBlob: Blob): File {
    let blob: any = theBlob;
    blob.lastModifiedDate = new Date();
    blob.name = this.expService.createFileName(this.data?.info?.documentNumber);
    return <File>blob;
  }

  _base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }


}

export type TSignedFileType = 'mio_sample_ecp' | 'mio_consent_file';

export interface IFormPdfSignatureComponentData {
  signType: TSignedFileType;
  info: IFormPdfSignatureComponentDataExpertiseInfo;
}

export interface IFormPdfSignatureComponentDataExpertiseInfo {
  objectName: string;
  expertiseID: number;
  livingComplexID: number;
  documentNumber: string;
  documentDate: string;
  expertiseType: number;
  regionID: number;
  // isIntegration: boolean;
  // isActive: boolean;
  // attachment: File;
}

export interface ISignFileOptions {
  url: string;
  filename: string;
  signMethod: 'cms' | 'detached_cms' | 'pdf';
  downloadMethod: 'js' | 'progressjs' | 'module' | 'local'; // aviable 'js', 'progressjs', 'module', 'local'
  log: boolean; //will log some messages to the console
  alert: boolean; //will show some messages to the console
  saveResultToFile: boolean; // need to save signed file,
  verbose: boolean;
  // locale: 'ru' | 'kk' | 'en';
}

export interface IPdfSignFIle {
  name: string;
  url: string;
  downloadName: string;
  base64String: string;
}
